import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {elementIdSchema} from '../../schemas';

const toolName = 'get-form-input-required' as const;

const argumentZod = z.object({
  elementId: elementIdSchema.describe(
    'The ID of the form input element to get the required status from. Must be one of: FormCheckboxInput, FormFileUploadWrapper, FormRadioInput, FormSelect, FormTextarea, or FormTextInput.'
  ),
});

export const getFormInputRequiredTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get form input required status',
  llmTool: {
    name: toolName,
    description: dedent`
      Retrieve the required status of a form input element. Returns true if the
      input is marked as required (user must fill it out), false otherwise. Works
      with form input types: FormCheckboxInput, FormFileUploadWrapper, FormRadioInput,
      FormSelect, FormTextarea, and FormTextInput. Required inputs prevent form
      submission until filled out.`,
    inputSchema: argumentZod,
  },
  type: 'designer',
  confirmBeforeExecuting: false, // Read-only operation
  timeout: 30000, // 30 seconds for retrieving required status
});
